"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DEFAULTS = void 0;
var react_1 = __importStar(require("react"));
var icons_1 = require("@material-ui/icons");
var Utils = __importStar(require("../../../utils"));
var button_1 = require("../../../ui/button");
var loader_1 = __importDefault(require("../../../ui/loader"));
var Data = __importStar(require("../../interface/product/data"));
exports.DEFAULTS = {
    endpoint: '/product/subscribe',
    label: 'Refresh Assets',
    messages: {
        success: 'Successfully refreshed assets',
        error: 'Something went wrong while refreshing assets'
    }
};
var AssetsButton = function (_a) {
    var disabled = _a.disabled, _b = _a.withBackend, withBackend = _b === void 0 ? false : _b;
    var _c = react_1.useState(false), loading = _c[0], setLoading = _c[1];
    var enqueueSnackbar = Utils.useSnackbar().enqueueSnackbar;
    var handleClick = function () {
        setLoading(true);
        Data.subscribe(withBackend)
            .then(function (r) {
            setLoading(false);
            Utils.confirmMessage(enqueueSnackbar, exports.DEFAULTS.messages.success, 'success');
        })["catch"](function (err) {
            setLoading(false);
            Utils.confirmMessage(enqueueSnackbar, exports.DEFAULTS.messages.error, 'error');
        });
    };
    if (loading) {
        return react_1["default"].createElement(loader_1["default"], null);
    }
    return (react_1["default"].createElement(button_1.Button, { disabled: disabled, label: react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(icons_1.Refresh, null),
            " ",
            exports.DEFAULTS.label), onClick: handleClick, primary: true }));
};
exports["default"] = AssetsButton;
